import { HttpClient } from '@angular/common/http';
import { computed, Injectable, signal } from '@angular/core';
import { environment } from '../../environments/environment';
import { IControllerDetail, IControllerList } from '../models/controller';

@Injectable({
  providedIn: 'root',
})
export class Controller {
  private baseUrl: string = `${environment.apiUrl}/controller`;

  constructor(private http: HttpClient) {}

  //signals for state
  controllers = signal<IControllerList[]>([]);
  controller = signal<IControllerDetail | null>(null);
  controllerRequired = computed(() => {
    const value = this.controller();
    if (!value) {
      return null;
    }
    return value;
  });
  isLoading = signal(false);
  errorMessage = signal('');

  /** Gets controllers from backend and updates signals */
  getControllerList(): void {
    this.isLoading.set(true);
    this.errorMessage.set('');

    this.http.get<IControllerList[]>(`${this.baseUrl}/list/all`).subscribe({
      next: (data) => {
        this.controllers.set(data);
        this.isLoading.set(false);
      },
      error: (err) => {
        console.error(err);
        this.errorMessage.set('Failed to load controllers.');
        this.isLoading.set(false);
      },
    });
  }

  /** Gets controller from backand and updates signals */
  getControllerDetails(controllerId: number) {
    this.isLoading.set(true);
    this.errorMessage.set('');

    this.http
      .get<IControllerDetail>(`${this.baseUrl}/${controllerId}`)
      .subscribe({
        next: (data) => {
          this.controller.set(data);
          this.isLoading.set(false);
        },
        error: (err) => {
          console.error(err);
          this.errorMessage.set('Failed to load controller');
          this.isLoading.set(false);
        },
      });
  }

  updateFromSocket(data: IControllerDetail) {
    this.controller.set(data);
  }
}
